import React from 'react';
const NotFound = () => {
    return <div className="flex justify-center dark: text-white">
        <h3 className="mt-4 text-lg">Page not found</h3>
    </div>
}

export default NotFound;